import { Subscribe } from '../utils/Subscribe'
import { DeviceInfo } from '../typings/DeviceInfo'
import { JSBridgeProtocol, JSBridgeReturnType } from '../typings/JSBridgeProtocol'
import { OpenWebViewEnum } from '../typings/OpenWebViewEnum'
import { ShareConfig } from '../typings/ShareConfig'
import { UserInfo } from '../typings/UserInfo'
import { WebViewEventMap } from '../typings/WebViewEventMap'
import { WebViewState, OrientationEnum } from '../typings/WebViewState'
import { WebViewTypeEnum } from '../typings/WebViewTypeEnum'
import { StaticData } from '../typings/StaticData'

/**
 * jsBridge 基础类
 */
export abstract class JSBridgeCore extends Subscribe<WebViewEventMap> implements JSBridgeProtocol {
  webViewType: WebViewTypeEnum = WebViewTypeEnum.Unsupported

  abstract ready(): Promise<JSBridgeReturnType<boolean>>
  abstract callAndBackfeed<T>(schemeUrl: string): Promise<JSBridgeReturnType<false | T>>
  abstract callAndListen<T>(
    schemeUrl: string,
    callback: (data: T) => void,
  ): Promise<JSBridgeReturnType<false | (() => void)>>
  abstract loadProgress(progress: number): Promise<JSBridgeReturnType<boolean>>
  abstract closeLoading(): Promise<JSBridgeReturnType<boolean>>
  abstract getDeviceInfo(): Promise<JSBridgeReturnType<false | DeviceInfo>>
  abstract getStaticData(): Promise<JSBridgeReturnType<false | StaticData>>
  abstract getWebViewState(): Promise<JSBridgeReturnType<false | WebViewState>>
  abstract setLeftTopBackButton(enable: boolean): Promise<JSBridgeReturnType<boolean>>
  abstract login(): Promise<JSBridgeReturnType<false | UserInfo>>
  abstract logout(): Promise<JSBridgeReturnType<boolean>>
  abstract getUserInfo(): Promise<JSBridgeReturnType<false | UserInfo>>
  abstract openWebView(url: string, way: OpenWebViewEnum): Promise<JSBridgeReturnType<boolean>>
  abstract closeWebView(): Promise<JSBridgeReturnType<boolean>>
  abstract getBangsHeight(): Promise<JSBridgeReturnType<number | false>>
  abstract setOrientation(orientation: OrientationEnum): Promise<JSBridgeReturnType<boolean>>
  abstract keepScreenLight(enable: boolean): Promise<JSBridgeReturnType<boolean>>
  abstract shock(duration?: number): Promise<JSBridgeReturnType<boolean>>
  abstract minimize(): Promise<JSBridgeReturnType<boolean>>
  abstract saveImage2Album(base64: string): Promise<JSBridgeReturnType<boolean>>
  abstract detectMicro(): Promise<JSBridgeReturnType<boolean>>
  abstract actionShare(shareConfig: Partial<ShareConfig>): Promise<JSBridgeReturnType<boolean>>
  abstract preload(urls: string[]): Promise<JSBridgeReturnType<boolean>>
  abstract createCacheProxyUrl(urls: string | string[]): string[]
}
